/* unplugin-vue-components disabled */import { render } from "./ingest-acl.vue?vue&type=template&id=a15cd58a&scoped=true"
import script from "./ingest-acl.vue?vue&type=script&lang=js"
export * from "./ingest-acl.vue?vue&type=script&lang=js"

import "./ingest-acl.vue?vue&type=style&index=0&id=a15cd58a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15cd58a"],['__file',"src/pages/settings/superuser/ingest/ingest-acl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a15cd58a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a15cd58a', __exports__)) {
    api.reload('a15cd58a', __exports__)
  }
  
  module.hot.accept("./ingest-acl.vue?vue&type=template&id=a15cd58a&scoped=true", () => {
    api.rerender('a15cd58a', render)
  })

}


export default __exports__